import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ProgramTypeRef } from "./ProgramTypeRef";
import type { ProgramTypeStaff } from "./ProgramTypeStaff";
import type { RatingProgramDTOBase } from "./RatingProgramDTOBase";
import type { RatingRef } from "./RatingRef";
import type { RatingStaff } from "./RatingStaff";
import type { TrackedBase } from "./TrackedBase";

export class RatingProgramStaff implements RatingProgramDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly ratingId: RatingStaff | null, public readonly programId: ProgramTypeStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly ratingIdTargetIds: RatingRef | null, public readonly programIdTargetIds: ProgramTypeRef | null) {
    this.cbiServiceContext = null;
    this.ratingIdLoaded = this.ratingId != null;
    this.ratingIdCached = this.ratingId;
    this.programIdLoaded = this.programId != null;
    this.programIdCached = this.programId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private ratingIdLoaded: boolean;
  private ratingIdCached: RatingStaff | null;
  private programIdLoaded: boolean;
  private programIdCached: ProgramTypeStaff | null;
  async ratingIdLazy(): Promise<RatingStaff | null> {
    if (!this.ratingIdLoaded) {
      this.ratingIdCached = await (this.ratingIdTargetIds != null ? this.cbiServiceContext!.ratingService().getRatingStaff(this.ratingIdTargetIds.ratingId) : Promise.resolve(null));
      this.ratingIdLoaded = true;
    }
    return this.ratingIdCached;
  }
  async programIdLazy(): Promise<ProgramTypeStaff | null> {
    if (!this.programIdLoaded) {
      this.programIdCached = await (this.programIdTargetIds != null ? this.cbiServiceContext!.programTypeService().getProgramTypeStaff(this.programIdTargetIds.programId) : Promise.resolve(null));
      this.programIdLoaded = true;
    }
    return this.programIdCached;
  }
}
